// NGRX
import { createFeatureSelector, createSelector } from '@ngrx/store';
// CRUD
import { QueryResultsModel } from '../../_base/crud';
// State
import { PharmaciesState } from '../_reducers/pharmacy.reducers';
import { Pharmacy } from '../_models/pharmacy.model';

export const selectPharmaciesState = createFeatureSelector<PharmaciesState>('pharmacies');

export const selectPharmacyById = (pharmacyId: number) =>
  createSelector(selectPharmaciesState, (pharmaciesState) => pharmaciesState.entities[pharmacyId]);

export const selectPharmaciesPageLoading = createSelector(
  selectPharmaciesState,
  (pharmaciesState) => {
    return pharmaciesState.listLoading;
  },
);

export const selectPharmaciesActionLoading = createSelector(
  selectPharmaciesState,
  (pharmaciesState) => pharmaciesState.actionsloading,
);

export const selectLastCreatedPharmacyId = createSelector(
  selectPharmaciesState,
  (pharmaciesState) => pharmaciesState.lastCreatedPharmacyId,
);

export const selectPharmaciesPageLastQuery = createSelector(
  selectPharmaciesState,
  (pharmaciesState) => pharmaciesState.lastQuery,
);
export const selectPharmacyError = createSelector(
  selectPharmaciesState,
  (pharmaciesState) => pharmaciesState.error,
);
export const selectPharmacyLatestSuccessfullAction = createSelector(
  selectPharmaciesState,
  (pharmaciesState) => pharmaciesState.latestSuccessfullAction,
);
export const selectPharmaciesInStore = createSelector(selectPharmaciesState, (pharmaciesState) => {
  const items = (pharmaciesState.ids as number[])
    .map((id) => pharmaciesState.entities[id])
    .filter((item): item is Pharmacy => item !== undefined);
  return new QueryResultsModel(items, pharmaciesState.totalCount);
});

export const selectPharmaciesShowInitWaitingMessage = createSelector(
  selectPharmaciesState,
  (pharmaciesState) => pharmaciesState.showInitWaitingMessage,
);

export const selectHasPharmaciesInStore = createSelector(selectPharmaciesState, (queryResult) => {
  if (!queryResult.totalCount) {
    return false;
  }

  return true;
});
